export { ContentfulImage as default } from './contentful-image';
export * from './contentful-image';
